// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sw","itemWrapper":"sx rW","itemStyle":"sy rX"};